import { ContentNetwork, ContentTier } from '@wit-support/admin-contracts';
/** Все сети контента — из Zod-перечисления admin-contracts. */
export const CONTENT_NETWORKS = ContentNetwork.options;
/**
 * Сеть → шкала Radix. `Record` проверяет полноту при сборке, тест
 * `content.test.ts` — что у каждой сети есть токены в `theme.css`.
 */
export const CONTENT_NETWORK_HUE = {
    instagram: 'purple',
    tiktok: 'teal',
    youtube: 'red',
    facebook: 'blue',
    threads: 'slate',
};
/** Имя токена цвета сети: `--color-network-tiktok-solid`. */
export function contentNetworkColorToken(network, part = 'solid') {
    return `--color-network-${network}-${part}`;
}
/**
 * Ярус силы клипа → вариант `Badge`. Спека v2 §1: сильный — зелёный,
 * рабочий — синий, слабый — серый; «нет данных» — обведённый, чтобы не
 * читаться как «слабый».
 */
export const CONTENT_TIER_BADGE_VARIANT = {
    strong: 'success',
    working: 'info',
    weak: 'neutral',
    no_data: 'outline',
};
export const CONTENT_TIERS = ContentTier.options;
/** Удачный ролик — кратность к обычному ролику аккаунта от ×3. */
export const CONTENT_HIT_MULTIPLE = 3;
/** Провал — кратность не больше ×0,33. */
export const CONTENT_FLOP_MULTIPLE = 0.33;
/**
 * Тон кратности: `hit` (≥ ×3, зелёный), `flop` (≤ ×0,33, красный), иначе
 * `normal`. Нет числа — `null` (тире без цвета).
 */
export function contentMultipleTone(x) {
    if (x === null || x === undefined || !Number.isFinite(x))
        return null;
    if (x >= CONTENT_HIT_MULTIPLE)
        return 'hit';
    if (x <= CONTENT_FLOP_MULTIPLE)
        return 'flop';
    return 'normal';
}
/** Класс цвета текста по тону кратности (литералы — для сканера Tailwind). */
export const CONTENT_MULTIPLE_TONE_CLASS = {
    hit: 'font-semibold text-[var(--color-state-success-fg)]',
    flop: 'font-semibold text-[var(--color-state-danger-fg)]',
    normal: 'text-[var(--color-text-primary)]',
};
/** Цвет стрелки тренда: рост — зелёный, падение — красный, без изменений — серый. */
export const CONTENT_TREND_TONE_CLASS = {
    up: 'text-[var(--color-state-success-fg)]',
    down: 'text-[var(--color-state-danger-fg)]',
    flat: 'text-[var(--color-text-muted)]',
};
//# sourceMappingURL=content.js.map